package ir.yusefpasha.style

import com.varabyte.kobweb.compose.css.CSSTransition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.silk.components.style.ComponentStyle
import com.varabyte.kobweb.silk.components.style.hover
import ir.yusefpasha.models.Theme
import ir.yusefpasha.util.Constants
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px

val ServiceCardStyle by ComponentStyle {
    base {
        Modifier
            .border(
                width = 2.px,
                style = LineStyle.Solid,
                color = Theme.LighterGray.rgb
            )
            .backgroundColor(Theme.LighterGray.rgb)
            .transition(
                CSSTransition(property = "border", duration = Constants.ANIMATION_DURATION),
                CSSTransition(property = "background", duration = Constants.ANIMATION_DURATION)
            )
    }

    hover {
        Modifier
            .border(
                width = 2.px,
                style = LineStyle.Solid,
                color = Theme.Primary.rgb
            )
            .backgroundColor(Theme.Primary.rgb)
            .transition(
                CSSTransition(property = "border", duration = Constants.ANIMATION_DURATION),
                CSSTransition(property = "background", duration = Constants.ANIMATION_DURATION)
            )
    }

    //I Don`t Know What is that
    cssRule(" > #iconBox") {
        Modifier
            .backgroundColor(Colors.Transparent)
            .transition(
                CSSTransition(property = "background", duration = Constants.ANIMATION_DURATION)
            )
    }

    cssRule(":hover > #iconBox") {
        Modifier
            .backgroundColor(Colors.White)
            .transition(
                CSSTransition(property = "background", duration = Constants.ANIMATION_DURATION)
            )
    }

    cssRule(" > p") {
        Modifier
            .color(Theme.Secondary.rgb)
            .transition(
                CSSTransition(property = "color", duration = Constants.ANIMATION_DURATION)
            )
    }

    cssRule(":hover > p") {
        Modifier
            .color(Colors.White)
            .transition(
                CSSTransition(property = "background", duration = Constants.ANIMATION_DURATION)
            )
    }
}